import { RuntimeConfigs } from '../../configs/runtime.js'
import { LogLevel } from '../@types/index.js'
import { createClientLogger } from './client-logger.js'

const isClient = typeof window !== 'undefined'

export const defaultLogger = createClientLogger({
  level: isClient ? (RuntimeConfigs.CLIENT_LOG_LEVEL as LogLevel) : 'silent',
})
